/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { useCalculator, STEPS } from './use-calculator'
import { SectionHeader, SectionBody, Flyout, parseDate } from '../twd/twd'
import { Action } from './calc-input/action'
import { PriceOrYield } from './calc-input/price-or-yield'
import { PriceYield } from './calc-input/price-yield'
import { Quantity } from './calc-input/quantity'
import { Settlement } from './calc-input/settlement'
import { getCalcInputErrors, } from './get-calc-input'

export const CalcInput = () => {

    const { step, cusip, calcInput, bondInfo, setCalcInput, setCalcOutput } = useCalculator()

    const input = calcInput || {}
    const [action, setAction] = React.useState(input.action || 'B')
    const [priceOrYield, setPriceOrYield] = React.useState(input.priceOrYield || 1)
    const [priceYield, setPriceYield] = React.useState(input.priceYield)
    const [qty, setQty] = React.useState(input.qty)
    const [settlement, setSettlement] = React.useState(input.settlement)
    const [showSection, setShowSection] = React.useState(true)
    const [errors, setErrors] = React.useState({})

    React.useEffect(() => {
        if (!bondInfo) { return }

        if (!settlement && bondInfo.settlement) {
            setSettlement(bondInfo.settlement)
        }

        const issue = (bondInfo && bondInfo.issue) || {}
        const stl = parseDate(settlement || bondInfo.settlement)
        const mat = parseDate(issue.maturity)
        if (stl && mat && stl>mat) {
            setErrors(Object.assign(errors, {
                settlement: 'Date cannot exceed Maturity date'
            }))
        }

    }, [bondInfo])

    React.useEffect(() => {
        if (step!==STEPS.CUSIP_INPUT) return
        setAction('B')
        setPriceOrYield(1)
        setPriceYield('')
        setQty('')
        setShowSection(true)
        setErrors({})
    }, [step])


    const isShow = bondInfo && bondInfo.canCalc
    if (!isShow) return null

    const ci = { cusip, action, priceOrYield, priceYield, qty, settlement }

    const onEnter = (isShowError) => {
        const err = getCalcInputErrors(bondInfo, ci)
        const hasErr = Object.keys(err).length>0
        if (hasErr && !isShowError) {
            return
        }

        setErrors(err)
        setCalcOutput(null)
        setCalcInput(ci)
    }

    return <React.Fragment>
        <div className="row">
        <div className={"col-md-12"}>
            <SectionHeader
                title="Calculator inputs"
                afterTitle={<Flyout html={calcInputTooltip} ariaLabel='Calculator inputs information'/>}
                cls="subhead"
                arrowSize='large'
                show={showSection}
                setShow={setShowSection}
            />
        </div>
        </div>

        <SectionBody show={showSection}>
        <div className="row">
        <div className="col-xs-12 col-auto xs-hide"  style={{minWidth:'10px', }}></div>

        <div className="col-xs-12 col-auto" style={{minWidth:'116px', }}>
            <Action
                action={action}
                setAction={setAction} />
        </div>
        <div className="col-xs-12 col-auto"  style={{minWidth:'116px', }}>
            <PriceOrYield
                priceOrYield={priceOrYield}
                setPriceOrYield={setPriceOrYield}
                />
        </div>
        <div className="col-xs-12 col-auto"  style={{minWidth:'130px', }}>
            <PriceYield
                priceOrYield={priceOrYield}
                priceYield={priceYield}
                setPriceYield={setPriceYield}
                err={errors.priceYield}
                bondInfo={bondInfo}
                action={action}
                isLoading={step===STEPS.INIT_LOADING || step===STEPS.CUSIP_LOADING || step===STEPS.CALC_LOADING }
                onEnter={onEnter}
                />
        </div>
        <div className="col-xs-12 col-auto"  style={{minWidth:'103px', }}>
            <Quantity
                quantity={qty}
                setQuantity={setQty}
                err={errors.quantity}
                onEnter={onEnter}
            />
        </div>
        <div className="col-xs-12 col-auto"  style={{minWidth:'120px', }}>
            <Settlement
                settlement={settlement}
                setSettlement={setSettlement}
                err={errors.settlement}
                bondInfo={bondInfo}
                onEnter={onEnter}
                />
        </div>
        <div className="col-xs-12 col-auto"  style={{minWidth:'100px', }}>
        <div className={'from-group '}
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <button
                type="button"
                className="btn btn-primary btn-block"
                style={{marginTop:'20px'}}
                onClick={() => {
                    onEnter(true)
                }}
            >Calculate</button>
            </div>

        </div>
        </div>

        <div className="row xs-show md-show vertical-offset-base"></div>
        </SectionBody>
    </React.Fragment>
}


const calcInputTooltip = `
<p>To run a calculation using this tool, several inputs must be populated by the user.  First, using the “Action” menu, indicate whether you are buying or selling the bond in this hypothetical trade scenario.  Next, choose whether you wish to calculate based upon a target price or yield value under the “Calculate using” menu.  Next, input the target price or yield aligning with the former selection.  Lastly, input the quantity of bonds you’re buying or selling for this scenario.</p>

<p>Please note:
<ul>
<li>The “Action” menu will default to the “Buy” selection</li>
<li>The “Calculate using” menu will default to the “Price” selection</li>
<li>The “Price” field will be pre-populated with the current best available offer price (when available)</li>
<li>The “Settlement Date” will always default to regular way settlement, assuming the present day as trade date</li>
</ul>
</p>

<p>Users can interact with each of these menus and manually change the variables for custom scenarios. Results generated from default or custom inputs may not align with live market trade outcomes.</p>

`